'use client';

import React from 'react';
import * as SubframeUtils from '../utils';

interface TableCellTwoLinesRootProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  className?: string;
}

const TableCellTwoLinesRoot = React.forwardRef<HTMLDivElement, TableCellTwoLinesRootProps>(
  function TableCellTwoLinesRoot({ title, subtitle, className, ...otherProps }, ref) {
    return (
      <div
        className={SubframeUtils.twClassNames('flex flex-col gap-0.5', className)}
        ref={ref}
        {...otherProps}
      >
        <span className="text-body text-default-font font-medium">{title}</span>
        {subtitle ? (
          <span className="text-caption font-caption text-subtext-color line-clamp-1">
            {subtitle}
          </span>
        ) : null}
      </div>
    );
  },
);

export const TableCellTwoLines = TableCellTwoLinesRoot;
